import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import stockTransferService from "../services/stockTransferService";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import StorageService from "../services/StorageService";
import utility from "../utils/utility";
import logo from "../assets/images/deviops_logo.png";

export default function ViewStockTransfer() {
  const { id } = useParams(); // ✅ GET ID FROM URL
  const navigate = useNavigate();
  const printRef = useRef();
  const companyName = StorageService.activeCompany()?.companyName || "";
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [header, setHeader] = useState(null);

  // const formatDate = (dateStr) => {
  //   if (!dateStr) return "-";
  //   const d = new Date(dateStr);
  //   if (isNaN(d)) return dateStr;

  //   const day = String(d.getDate()).padStart(2, "0");
  //   const month = String(d.getMonth() + 1).padStart(2, "0");
  //   const year = d.getFullYear();

  //   return `${day}-${month}-${year}`; // DD-MM-YYYY
  // };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return utility.formatDateDDMMMYYYY(dateStr);
  };

  const formatEmployee = (name, code) => {
    if (name && code) return `${name} (${code})`;
    return name || code || "-";
  };

  const formatProject = (name, code, categoryName) => {
    const categoryInitial = String(categoryName || "").trim().charAt(0).toUpperCase();
    if (name) {
      if (categoryInitial) return `${categoryInitial}*${name}`;
      if (code) {
        const codeInitial = String(code).trim().charAt(0).toUpperCase();
        return `${codeInitial}*${name}`;
      }
      return name;
    }
    return "-";
  };

  const formatQty = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    const num = Number(val);
    return isNaN(num) ? "-" : num.toFixed(3);
  };
  
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "Material-Transfer-Slip",
  });

  useEffect(() => {
    const loadDetails = async () => {
      try {
        setLoading(true);
        const res = await stockTransferService.getById(id);

        // ✅ correct key from backend
        setHeader(res?.data || null);
        setRows(res?.data?.stockTransferDetails || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) loadDetails();
  }, [id]);


  return (
    <>
      <Breadcrumb pageTitle="Stock Transfer Details" secondTitle="Inventory" />
      
        <div className="d-flex align-items-center gap-2 mb-3">

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>

          <button
            className="btn btn-success"
            onClick={handlePrint}
          >
            <i className="ti ti-printer me-1"></i> Print
          </button>

        </div>
      
      

      <div className="card p-3 bg-white shadow-sm">
        <div className="table-responsive">
          {header && (
            <div className="row mb-3">

              <div className="col-md-4">
                <strong>Voucher No:</strong> {header.vocherNo}
              </div>
              <div className="col-md-4 text-end">
                <strong>Transfer Date:</strong> {formatDate(header.transferDate)}
              </div>

              <div className="col-md-6 mt-2">
                <strong>From Company:</strong> {header.fromCompanyName}
              </div>
              <div className="col-md-6 mt-2">
                <strong>To Company:</strong> {header.toCompanyName}
              </div>

              <div className="col-md-6 mt-2">
                <strong>From Project:</strong> {formatProject(header.fromProjectName, header.fromProjectCode, header.fromProjectCategoryName)}
              </div>
              <div className="col-md-6 mt-2">
                <strong>To Project:</strong> {formatProject(header.toProjectName, header.toProjectCode, header.toProjectCategoryName)}
              </div>

              <div className="col-md-6 mt-2">
                <strong>From Store:</strong> {header.fromStoreName}
              </div>
              <div className="col-md-6 mt-2">
                <strong>To Store:</strong> {header.toStoreName}
              </div>

                <div className="col-md-6 mt-2">
                  <strong>Transporter:</strong> {header.transporterName || "-"}
              </div>
              
              <div className="col-md-6 mt-2">
                <strong>Vehicle No:</strong> {header.vehicleNo || "-"}
              </div>

              <div className="col-md-6 mt-2">
                <strong>Status:</strong>{" "}
                <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>
                  {(header.status || "-").toUpperCase()}
                </span>
              </div>

              <div className="col-md-6 mt-2">
                <strong>Remarks / Transfer Note:</strong> {header.stockTransferNote || "-"}
              </div>

              <div className="col-md-6 mt-2">
                <strong>Created By:</strong> {formatEmployee(header.createdByName, header.createdByCode)}
              </div>

              {/* Conditional Action Notes */}
              {header.status?.toLowerCase() === "received" && (
                <>
                  <div className="col-md-6 mt-2">
                    <strong>Received / Approved By:</strong> {formatEmployee(header.receivedByName, header.receivedByCode)}
                  </div>
                  <div className="col-md-6 mt-2">
                    <strong>Received Notes:</strong> {header.receivedNotes || header.approvedNotes || "-"}
                  </div>
                </>
              )}

              {header.status?.toLowerCase() === "rejected" && (
                <>
                  <div className="col-md-6 mt-2">
                    <strong>Rejected By:</strong> {formatEmployee(header.rejectedByName, header.rejectedByCode)}
                  </div>
                  <div className="col-md-6 mt-2">
                    <strong>Rejection Notes:</strong> {header.rejectedNotes || "-"}
                  </div>
                </>
              )}

              {header.status?.toLowerCase() === "cancelled" && (
                <>
                  <div className="col-md-6 mt-2">
                    <strong>Cancelled By:</strong> {formatEmployee(header.cancelledByName, header.cancelledByCode)}
                  </div>
                  <div className="col-md-6 mt-2">
                    <strong>Cancelled Notes:</strong> {header.cancelledNotes || "-"}
                  </div>
                </>
              )}

            </div>
          )}
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Item Category</th>
                <th>Item</th>
                <th>UOM</th>
                <th>Transfer Qty</th>
                <th>Received Qty</th>
                <th>Damaged Qty</th>
                <th>Scrap Store</th>
                <th>Missed Qty</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : rows.length > 0 ? (
                rows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.itemCategoryName || "-"}</td>
                    <td>{row.itemCode || row.itemName || "-"}</td>
                    <td>{row.UOM || row.uom || "-"}</td>
                    <td>{formatQty(row.quantity ?? row.transferQuantity)}</td>
                    <td>{formatQty(row.receivedQuantity)}</td>
                    <td>{formatQty(row.damagedQuantity)}</td>
                    <td>
                      {parseFloat(row.damagedQuantity || 0) > 0 && row.scrapStoreName
                        ? `${row.scrapStoreName}${row.scrapStoreCode ? ` (${row.scrapStoreCode})` : ""}`
                        : "-"}
                    </td>
                    <td>{formatQty(row.lostQuantity)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      
        {/* PRINT TEMPLATE */ }
        < div style={{ display: "none" }}>
      <div ref={printRef} className="print-container">

        <div className="print-top-header">
          <div className="print-top-left">
            <img src={logo} alt="Logo" className="print-logo" />
            <span className="print-company">{companyName}</span>
          </div>
          <div className="print-top-right">
            <b>Printed Date:</b> {utility.formatExportDateTime(new Date())}
          </div>
        </div>

        <h3 className="print-title">Material Transfer Slip</h3>

        <table className="print-header">
          <tbody>

            <tr>
              <td><b>From Company:</b> {header?.fromCompanyName || "-"}</td>
              <td><b>To Company:</b> {header?.toCompanyName || "-"}</td>
            </tr>

            <tr className="project-store-row">
              <td><b>From Project:</b> {formatProject(header?.fromProjectName, header?.fromProjectCode, header?.fromProjectCategoryName)}</td>
              <td><b>To Project:</b> {formatProject(header?.toProjectName, header?.toProjectCode, header?.toProjectCategoryName)}</td>
            </tr>

            <tr className="project-store-row">
              <td><b>From Store:</b> {header?.fromStoreName || "-"}</td>
              <td><b>To Store:</b> {header?.toStoreName || "-"}</td>
            </tr>

            <tr>
               <td><b>Vehicle Number:</b> {header?.vehicleNo || "-"}</td>
              <td><b>Voucher No:</b> {header?.vocherNo || "-"}</td>
            </tr>

            <tr>
              <td><b>Transporter:</b> {header?.transporterName || "-"}</td>
              <td><b>Transaction Date:</b> {formatDate(header?.transferDate)}</td>
            </tr>

            <tr>
              <td><b>Status:</b> {header?.status ? header.status.toUpperCase() : "-"}</td>
              <td><b>Created By:</b> {formatEmployee(header?.createdByName, header?.createdByCode)}</td>
            </tr>

            {header?.status?.toLowerCase() === "received" && (
              <tr>
                <td><b>Received / Approved By:</b> {formatEmployee(header?.receivedByName, header?.receivedByCode)}</td>
                <td><b>Received Notes:</b> {header?.receivedNotes || header?.approvedNotes || "-"}</td>
              </tr>
            )}

            {header?.status?.toLowerCase() === "rejected" && (
              <tr>
                <td><b>Rejected By:</b> {formatEmployee(header?.rejectedByName, header?.rejectedByCode)}</td>
                <td><b>Rejection Notes:</b> {header?.rejectedNotes || "-"}</td>
              </tr>
            )}

            {header?.status?.toLowerCase() === "cancelled" && (
              <tr>
                <td><b>Cancelled By:</b> {formatEmployee(header?.cancelledByName, header?.cancelledByCode)}</td>
                <td><b>Cancelled Notes:</b> {header?.cancelledNotes || "-"}</td>
              </tr>
            )}

            <tr>
              <td colSpan="2"><b>Transfer Note:</b> {header?.stockTransferNote || "-"}</td>
            </tr>

          </tbody>
        </table>

        <table className="print-table">
          <thead>
            <tr>
              <th className="text-center">S.No</th>
              <th className="text-start">Item Category</th>
              <th className="text-start">Item Code</th>
              <th className="text-start">UOM</th>
              <th className="text-end">Transfer Qty</th>
              <th className="text-end">Received Qty</th>
              <th className="text-end">Damaged Qty</th>
              <th className="text-start">Scrap Store</th>
              <th className="text-end">Missed Qty</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td className="text-center">{i + 1}</td>
                <td className="text-start">{r.itemCategoryName || "-"}</td>
                <td className="text-start">{r.itemCode || r.itemName || "-"}</td>
                <td className="text-start">{r.UOM || r.uom || "-"}</td>
                <td className="text-end">{formatQty(r.quantity ?? r.transferQuantity)}</td>
                <td className="text-end">{formatQty(r.receivedQuantity)}</td>
                <td className="text-end">{formatQty(r.damagedQuantity)}</td>
                <td className="text-start">
                  {parseFloat(r.damagedQuantity || 0) > 0 && r.scrapStoreName
                    ? `${r.scrapStoreName}${r.scrapStoreCode ? ` (${r.scrapStoreCode})` : ""}`
                    : "-"}
                </td>
                <td className="text-end">{formatQty(r.lostQuantity)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ marginTop: "60px", display: "flex", justifyContent: "space-between" }}>
          <div>Issued Store Incharge Signature</div>
          <div>Received Store Incharge Signature</div>
          <div>PM/Incharge Signature</div>
        </div>

      </div>
    </div >
    </>
  );
}
